export const environment = {
  ENV: 'dev',
  PARENT_URL: 'http://localhost:3000',
  API_LLAMANOS: 'https://api.llamanos.copec.pharedata.com',
  PEDIDOS_API: 'https://api.pedidos.copec.pharedata.com',
  CUENTA_API: 'https://api.cuenta.copec.pharedata.com',
};
